import { render, staticRenderFns } from "./RequestClassroomForm.vue?vue&type=template&id=d1ff0cee&scoped=true"
import script from "./RequestClassroomForm.vue?vue&type=script&lang=js"
export * from "./RequestClassroomForm.vue?vue&type=script&lang=js"
import style0 from "./RequestClassroomForm.vue?vue&type=style&index=0&id=d1ff0cee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ff0cee",
  null
  
)

export default component.exports